module.exports = "/assets/89776a9d50dccec964629e99de756c87.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/KC.png
// module id = 1540
// module chunks = 0